import { render } from "./AchievementBar.vue?vue&type=template&id=3ef07207&scoped=true"
import script from "./AchievementBar.vue?vue&type=script&lang=js"
export * from "./AchievementBar.vue?vue&type=script&lang=js"

import "./AchievementBar.vue?vue&type=style&index=0&id=3ef07207&scoped=true&lang=scss"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef07207"]])

export default __exports__